<template>
  <div class="yxtbiz-rank" v-loading="loading">
    <div
      v-if="!Object.keys(configData).length"
      class="yxtbiz-rank__empty"
      :style="{ height: height ? height + 'px' : 'auto' }"
    >
      <div v-if="initFlag < 2">
        <yxtf-empty
          size="small"
          :empty-text="
            noFindRank
              ? $t('pc_biz_rank_no_find_rank').d('榜单不存在')
              : $t('pc_biz_rank_no_server').d('哎呀~服务器开小差啦~')
          "
          ><div slot="image" v-if="!noFindRank">
            <yxt-svg
              :remote-url="`${$staticBaseUrl}ufd/3f5568/common/h5/svg/`"
              icon-class="no-server"
            /></div
        ></yxtf-empty>
      </div>
    </div>
    <div v-else>
      <one-column
        :height="height"
        :rankData="rankData"
        v-if="styleType === 1"
        ref="rankList"
        :apiError="apiError"
        :initFlag="initFlag"
        @changeDate="changeDate"
        ><div slot="title"><slot name="title"></slot></div
      ></one-column>
      <two-columns
        :height="height"
        :rankData="rankData"
        :apiError="apiError"
        :initFlag="initFlag"
        ref="rankList"
        v-else
        @changeDate="changeDate"
        ><div slot="title"><slot name="title"></slot></div
      ></two-columns>
    </div>
  </div>
</template>

<script>
import { apiBaseUrl } from 'yxt-biz-pc/packages/api';
import oneColumn from './onecolumn';
import twoColumns from './twocolumns';
import { dictionaryKeys } from './config';
export default {
  name: 'YxtbizRank',
  components: {
    oneColumn,
    twoColumns
  },
  props: {
    // 榜单配置信息 -- rankId 榜单ID(必填); type 榜单类型: 1 平台榜、2 集团榜; showTop  展示Top
    rankConfig: {
      type: Object,
      default: () => ({ rankId: '', type: 1 })
    },
    // 展示样式: 1 列表式、2 横排式
    showStyle: {
      type: Number
    },
    // 样式类型: 1 一列式、2 两列式
    styleType: {
      type: Number,
      default: 1
    },
    // 隐藏头部（包含标题、时间筛选、部门筛选等）
    hideHeader: {
      type: Boolean,
      default: false
    },
    // 隐藏标题
    hideTitle: {
      type: Boolean,
      default: false
    },
    // 隐藏我的排名
    hideMyRank: {
      type: Boolean,
      default: false
    },
    // 排行榜高度
    height: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      configData: {}, // 榜单配置
      contentObj: {
        hasHead: false,
        primaryCode: '',
        secondaryCodes: [],
        attributeCode: '',
        attributeName: '',
        objectName: '',
        objectCode: '',
        type: 1
      }, // 榜单内容配置
      rankData: {}, // 榜单数据
      titleObj: {
        title: '',
        type: 1,
        showTop: 0,
        attributeName: '',
        showDate: false,
        defaultDateType: 1,
        dateArr: []
      }, // 榜单名称配置
      loading: false, // 加载中
      noFindRank: false, // 榜单不存在
      apiError: false, // 获取榜单数据的接口报错
      initFlag: 2 // 记录是否调用过接口
    };
  },
  provide() {
    return {
      contentFun: () => this.contentObj,
      styleFun: () => ({
        styleType: this.styleType,
        showStyle: this.showStyle || this.configData.rankStyle,
        hideTitle: this.hideTitle,
        hideHeader: this.hideHeader,
        hideMyRank: this.hideMyRank
      }),
      titleFun: () => this.titleObj
    };
  },
  watch: {
    rankConfig: {
      handler() {
        this.init();
      },
      deep: true
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化榜单
    async init() {
      if (this.rankConfig.rankId) {
        this.initFlag = 2;
        this.getRankConfig();
      }
    },
    // 获取榜单配置
    async getRankConfig() {
      const id = this.rankConfig.rankId;
      try {
        this.loading = true;
        const data = await apiBaseUrl.get(
          `/rank/ranklist/${this.rankConfig.rankId}/config`
        );
        if (id === this.rankConfig.rankId) {
          this.initFlag--;
          this.noFindRank = false;
          this.configData = data;
          this.getRankList();
          this.formatData();
        }
      } catch (err) {
        if (id === this.rankConfig.rankId) {
          this.loading = false;
          this.initFlag--;
          this.configData = {};
          this.noFindRank = err && err.error && err.error.code === 2891101;
        }
      }
    },
    // 获取榜单数据
    async getRankList(dateType) {
      const id = this.rankConfig.rankId;
      try {
        const params = {
          type: this.rankConfig.type ? Number(this.rankConfig.type) : 1,
          scopes: {}
        };
        const type = dateType
          ? dateType
          : this.configData.settings &&
            this.configData.settings[dictionaryKeys.dateScope] &&
            this.configData.settings[dictionaryKeys.dateScope].defaultType
            ? this.configData.settings[dictionaryKeys.dateScope].defaultType
            : 1;
        params.scopes[dictionaryKeys.dateScope] = JSON.stringify({ type });
        const limit =
          this.rankConfig.showTop > 0
            ? this.rankConfig.showTop
            : this.configData.showTop;
        const data = await apiBaseUrl.post(
          `/rank/ranklist/${this.rankConfig.rankId}?offset=0&limit=${limit}`,
          params
        );
        if (id === this.rankConfig.rankId) {
          this.apiError = false;
          this.initFlag--;
          this.rankData = data;
          this.height && this.$refs.rankList && this.$refs.rankList.scrollToTop();
          this.loading = false;
        }
      } catch (err) {
        if (id === this.rankConfig.rankId) {
          this.rankData = {};
          this.loading = false;
          this.initFlag--;
          this.apiError = true;
        }
      }
    },
    // 格式化数据
    formatData() {
      // 榜单内容配置
      let showContent = this.configData.showContents || [];
      const contentObj = {
        hasHead: false,
        primaryCode: '',
        secondaryCodes: [],
        attributeCode: '',
        attributeName: this.configData.attributeName,
        objectCode: this.configData.objectCode,
        objectName: this.configData.objectName,
        type: this.rankConfig.type ? Number(this.rankConfig.type) : 1
      };
      contentObj.hasHead = showContent.some(
        s => s.contentCode === dictionaryKeys.userImgUrl
      );
      showContent.some(s => s.contentCode === this.configData.attributeCode) &&
        (contentObj.attributeCode = this.configData.attributeCode);
      showContent = showContent
        .filter(
          s =>
            s.contentCode !== dictionaryKeys.userImgUrl &&
            s.contentCode !== this.configData.attributeCode &&
            (contentObj.type === 2 ||
              (contentObj.type === 1 &&
                s.contentCode !== dictionaryKeys.orgName))
        )
        .sort((a, b) => b.contentSort - a.contentSort)
        .map(c => c.contentCode);
      // 集团榜，有部门范围时，不显示平台名称
      if (
        contentObj.type === 2 &&
        showContent.includes(dictionaryKeys.orgName) &&
        this.configData.scopeCodes &&
        this.configData.scopeCodes.includes(dictionaryKeys.deptScope)
      ) {
        showContent = showContent.filter(s => s !== dictionaryKeys.orgName);
      }
      // 集团榜，部门名称和平台名称同时存在时，不显示部门名称
      if (
        contentObj.type === 2 &&
        showContent.includes(dictionaryKeys.orgName) &&
        showContent.includes(dictionaryKeys.deptName)
      ) {
        showContent = showContent.filter(s => s !== dictionaryKeys.deptName);
      }

      showContent.length && (contentObj.primaryCode = showContent.shift());
      showContent.length && (contentObj.secondaryCodes = showContent);
      this.contentObj = contentObj;
      // 榜单名称配置
      this.titleObj = {
        title: this.configData.title,
        attributeName: this.configData.attributeName,
        type: this.rankConfig.type ? Number(this.rankConfig.type) : 1,
        showTop: this.configData.showTop,
        showDate:
          this.configData.scopeCodes &&
          this.configData.scopeCodes.includes(dictionaryKeys.dateScope)
      };

      if (this.titleObj.showDate) {
        this.titleObj.defaultDateType =
          this.configData.settings &&
          this.configData.settings[dictionaryKeys.dateScope] &&
          this.configData.settings[dictionaryKeys.dateScope].defaultType
            ? this.configData.settings[dictionaryKeys.dateScope].defaultType
            : 1;

        this.titleObj.dateArr =
          this.configData.settings &&
          this.configData.settings[dictionaryKeys.dateScope] &&
          this.configData.settings[dictionaryKeys.dateScope].type
            ? this.configData.settings[dictionaryKeys.dateScope].type
            : [];
      }
    },
    // 日期更改时
    changeDate(type) {
      this.titleObj = { ...this.titleObj, defaultDateType: type };
      this.loading = true;
      this.getRankList(type);
    }
  }
};
</script>
<style lang="scss" scoped>
.yxtbiz-rank {
  width: 100%;

  .yxtbiz-rank__empty {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
